import styled from '@emotion/styled';
import type { SelectHTMLAttributes, PropsWithChildren, Ref } from 'react';
import { forwardRef } from 'react';
import { colors } from '@/constants/colors';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  width?: number | string;
  height?: number | string;
  fontSize?: number;
  fontWeight?: number;
  padding?: string;
  border?: string;
  borderRadius?: string;
  arrowRight?: number;
  showArrow?: boolean;
  backgroundColor?: string;
}

const SelectStyled = styled.select<SelectProps>`
width: ${({ width }) => typeof width === 'number' ? `${width}px` : width};
height: ${({ height = 46 }) => typeof height === 'number' ? `${height}px` : height};
${({ padding, showArrow = true, arrowRight = 12 }) => padding ? `
padding: ${padding};
` : `
padding: 10px ${showArrow ? arrowRight + 18 : 18}px 10px 18px;
`} 
border: ${({ border = `1px solid ${colors.lightGrey2}` }) => border};
-webkit-appearance: none;
-moz-appearance: none; 
appearance: none;
${({ arrowRight = 12, showArrow = true, backgroundColor = colors.transparent }) => showArrow ? `
background: url('/images/ic-dropdown-down.svg') no-repeat right ${arrowRight}px center;
background-color: ${backgroundColor};
` : `
background: ${backgroundColor};
`}
border-radius: ${({ borderRadius = '5px' }) => borderRadius};
color: ${colors.indigo};
font-size: ${({ fontSize = 15 }) => `${fontSize}px`};
font-weight: ${({ fontWeight = 500 }) => fontWeight};
line-height: 18px;
:focus {
  border-color: ${colors.blue};
  outline: .5px solid ${colors.blue};
}
`;

const NativeSelect = ({
  children,
  ...selectAttributes
}: PropsWithChildren<SelectProps>,
forwardedRef: Ref<HTMLSelectElement>) => (
  <SelectStyled
    ref={forwardedRef}
    {...selectAttributes}
  >{children}
  </SelectStyled>
);

export default forwardRef(NativeSelect);
